import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import { usePermissions } from "context/PermissionsContext";
import SortContext from "context/SortContext";
import Products from "features/Stock/StockProd/components/Products.jsx";
import React from "react";
import { useLocation } from "react-router-dom";
import { usePermissionFlags } from "utils/visionRights";
import apiClient from "lib/api-client";
import config from "configs/config";

const SubStockProd = () => {
  const { setSortOptions, setSelectedSortValue, sortOptions, selectedSortValue } = React.useContext(SortContext);
  const { setIsSetFilter, setFilterValues, setBackendFilterValues, setFilterCount } = useFilter();
  const { setSearchPlaceHolder, setDisplaySetIcon } = useGlobalContext();
  const { stockLocations } = usePermissionFlags();
  const permissions = usePermissions();
  const location = useLocation();
  const categoryName = location.state?.categoryName;
  const subCategoryName = location.state?.name?.[1]?.split("-")[0]?.trim();
  React.useEffect(() => {
    setIsSetFilter(true);
    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Make Date (Oldest to Newest)", sortBy: "Make Date", order: "asc" },
      { id: 6, name: "Make Date (Newest to Oldest)", sortBy: "Make Date", order: "desc" },
      { id: 7, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 8, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 9, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 10, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
      {
        id: 11,
        name: "Sales (Low to High)",
        sortBy: "Sales",
        order: "asc",
      },
      {
        id: 12,
        name: "Sales (High to Low)",
        sortBy: "Sales",
        order: "desc",
      },
    ]);

    setSearchPlaceHolder("Search by Jewel Code or Design Number");
    setDisplaySetIcon(true);
    return () => {
      setSearchPlaceHolder("Search");
      setIsSetFilter(false);
      setDisplaySetIcon(false);
      setFilterValues((prev) => {
        const locationLength = prev?.Location?.length || 0;
        const StockStatusCount = prev?.["Stock Status"]?.[0] && prev?.["Stock Status"]?.[0] !== "All" ? 1 : 0;

        const LocationFiltercount = stockLocations?.length - locationLength;
        // const LocationFiltercount = locationLength === 6 ? 0 : locationLength === 5 ? 1 : locationLength === 4 ? 2 : locationLength === 3 ? 3 : locationLength === 2 ? 4 : locationLength === 1 ? 5 : 0;
        // const LocationFiltercount = locationLength === 5 ? 0 : locationLength === 4 ? 1 : locationLength === 3 ? 2 : locationLength === 2 ? 3 : locationLength === 1 ? 4 : 0;
        //  locationLength === 1 ? 2 : 0;

        setFilterCount(LocationFiltercount + StockStatusCount);

        return {
          ...prev,
          Location: prev?.Location?.length ? prev.Location : [],
        };
      });
      setBackendFilterValues({});
      setSortOptions([]);
      setSelectedSortValue(null);
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  React.useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  React.useEffect(() => {
    const fetchFilterData = async () => {
      let baseFilterData = {
        "Diamond Quality": ["VVS-EF", "VVS-FG", "VVS-GH", "VSSI-GH", "VS-GH", "SI-IJ", "SI-HI"],
        "Gold Purity": ["22K", "18K", "14K"],
        "Gold Color": ["Yellow Gold", "Rose Gold", "White Gold"],
        Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
        Location: stockLocations.length > 0 ? stockLocations : [],
        "Stock Status": ["All","On Hand", "On Memo"],
        "Show Hidden Designs": false,
      };

      try {
        const response = await apiClient.post(`${config?.baseUrl}/api/v1/collection/getDesignSlidersData`, {
          categoryName,
          subCategoryName,
          isStock: true,
        });

        if (response?.status === 200) {
          const { diamondPieces, diamondWeight, grossWeight, netWeight, ratio } = response.data.data;
          baseFilterData = {
            ...baseFilterData,
            "Diamond Pieces": diamondPieces || [0, 100],
            "Diamond Weight": diamondWeight || [0, 100],
            "Gold Gross-Weight": grossWeight || [0, 100],
            "Gold Net-Weight": netWeight || [0, 100],
            // Ratio: ratio || [0, 100],
          };
        }
      } catch (error) {
        console.error("Error fetching slider data:", error);
      }

      const filterData = baseFilterData;

      setBackendFilterValues(filterData);
      setFilterValues((prev) => ({
        ...filterData,
        Location: prev?.Location?.length ? prev.Location : filterData.Location,
        "Stock Status": prev["Stock Status"] ? prev["Stock Status"] : filterData["Stock Status"],
      }));

      const filterChangeCount = JSON.parse(sessionStorage.getItem("filterChangeCount"));

      if (filterChangeCount === 0) {
        setFilterValues((prev) => ({
          ...filterData,
          "Stock Status": prev["Stock Status"] ? prev["Stock Status"] : filterData["Stock Status"],
        }));
      } else {
        const appliedFilterValues = JSON.parse(sessionStorage.getItem("appliedFilterValues"));
        setFilterValues({
          ...filterData,
          ...appliedFilterValues,
        });
      }
    };

    fetchFilterData();
  }, [permissions]);

  return <Products />;
};

export default SubStockProd;
